module.exports = __webpack_public_path__ + "static/ibmLogo-542347d99e44553cefd26715ded97c4e.png";